import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/chi-siamo',
    element: <AboutPage />,
  },
  {
    path: '/prodotti',
    element: <ProductsPage />,
  },
  {
    path: '/settori',
    element: <IndustriesPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/contatti',
    element: <ContactPage />,
  },
  {
    path: '/preventivo',
    element: <QuotePage />,
  },
  {
    path: '/richiedi-preventivo',
    element: <QuotePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
